import { type FC } from 'react';
import { useEffect } from 'react';
import { useNavigateWithSearchParams } from '../../lib/router';

type RedirectWithSearchParamsProps = {
    to: string;
    replace?: boolean;
};

export const RedirectWithSearchParams: FC<RedirectWithSearchParamsProps> = ({ to, replace }) => {
    const navigate = useNavigateWithSearchParams();

    useEffect(() => {
        navigate(to, { replace });
    }, [navigate, replace, to]);

    return null;
};
